import { withStyles, TableCell } from '@material-ui/core';

const StyledTableHeaderCell = withStyles((theme) => ({
  root: {
    padding: '6px',
    height: 'auto',
    color: theme.printTableLabel,
    fontWeight: 600,
    fontSize: theme.headerTextFontSize,
  },
  head: {
    border: `1px solid ${theme.printTableBorder}`
  },
}))(TableCell);

export default StyledTableHeaderCell;
